import { docReady } from '../helpers/doc-ready';
docReady(() => {
    const loadImage = (container, imageElement, imageSource) => {
        const firstAttempt = Date.now();
        const img = new Image();
        img.onerror = () => {
            console.log('imageSource', imageSource);
            if (Date.now() - firstAttempt < 20000) {
                setTimeout(function () {
                    img.src = imageSource;
                }, 1500);
            }
        };
        img.onload = () => {
            imageElement.src = imageSource;
            container.classList.remove('line-item__customily-thumb-container--loading-image');
        };
        img.src = imageSource;
    };
    const events = ['load', 'cart:change'];
    events.forEach((event) => {
        window.addEventListener(event, () => {
            setTimeout(() => {
                const customilyThumbnailContainers = document.querySelectorAll('.line-item__customily-thumb-container');
                customilyThumbnailContainers.forEach((container) => {
                    const customImage = container.querySelector('.line-item__customily-thumb');
                    const imgSrc = customImage === null || customImage === void 0 ? void 0 : customImage.src;
                    loadImage(container, customImage, imgSrc);
                });
            }, 2000); // Wait for cart drawer to be re-built (there is no event for this)
        });
    });
});
